var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"con_page"},[_c('div',{staticStyle:{"font-size":"14px","line-height":"34px","text-align":"left","padding":"10px"},domProps:{"innerHTML":_vm._s(_vm.materialData.materialContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }